import { render, staticRenderFns } from "./paysuccess.vue?vue&type=template&id=4008c6d8&scoped=true&"
import script from "./paysuccess.vue?vue&type=script&lang=js&"
export * from "./paysuccess.vue?vue&type=script&lang=js&"
import style0 from "./paysuccess.vue?vue&type=style&index=0&id=4008c6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4008c6d8",
  null
  
)

export default component.exports